import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-col space-y-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Intervention", -1)
const _hoisted_4 = { class: "flex items-center space-x-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm font-bold"
}
const _hoisted_6 = { class: "flex items-center space-x-2" }
const _hoisted_7 = { class: "flex items-center space-x-2" }
const _hoisted_8 = { class: "flex items-center space-x-2" }
const _hoisted_9 = { class: "flex items-center space-x-2" }
const _hoisted_10 = { class: "flex items-center space-x-2" }
const _hoisted_11 = { class: "flex items-center space-x-2" }
const _hoisted_12 = { class: "flex items-center space-x-2" }

import { onMounted, ref, computed, watch } from "vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import GuardianModal from "./Modals/GuardianModal.vue";
import CompanionModal from "./Modals/CompanionModal.vue";
import PatientAddressModal from "./Modals/PatientAddressModal.vue";
import PerpetratorModal from "./Modals/PerpetratorModal.vue";
import CaseConferenceModal from "./Modals/CaseConferenceModal.vue";
import { useRouter, useRoute } from "vue-router";
import { hasPermission } from "@/classes/AuthService";
import { useNetworkStore } from "@/store/network";
import pickBy from "lodash/pickBy";
import { useRecordStatusChecker } from "@/store/recordStatusChecker";

export default /*#__PURE__*/_defineComponent({
  __name: 'SideNav',
  props: {
	hasRecord: {
		type: Boolean,
		default: false,
	},
	item: {
		type: Object,
	},
    otherDetailsCount: {
        type: Object,
        default: null,
    }
},
  setup(__props) {

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const recordStatusChecker = useRecordStatusChecker();
const isRecordDeleted = computed(() => recordStatusChecker.isDeletedGuardian);
const isRecordCreated = computed(() => recordStatusChecker.isCreatedGuardian);
const isInformantDeleted = computed(() => recordStatusChecker.isDeletedInformant);
const isInformantCreated = computed(() => recordStatusChecker.isCreatedInformant);
const isPatientAddressDeleted = computed(() => recordStatusChecker.isDeletedPatientAddress);
const isPatientAddressCreated = computed(() => recordStatusChecker.isCreatedPatientAddress);
const isPerpetratorDeleted = computed(() => recordStatusChecker.isDeletedPerpetrator);
const isPerpetratorCreated = computed(() => recordStatusChecker.isCreatedPerpetrator);
const router = useRouter();
const route = useRoute();



const showGuardianModal = ref<boolean>(false);
const showCompanionModal = ref<boolean>(false);
const showPatientAddressModal = ref<boolean>(false);
const showPerpetratorModal = ref<boolean>(false);
const showCaseConferenceModal = ref<boolean>(false);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const offlineParams = ref<string>(route.query.offline);
const intake = ref<object>(null);
const assessment = ref<object>(null);

const closeModals = () => {
    showGuardianModal.value = false;
    showCompanionModal.value = false;
    showPatientAddressModal.value = false;
    showPerpetratorModal.value = false;
}

// watch(
// 	() => isNetworkAvailable.value,
// 	(val) => {
// 		console.log("Watcher - Network: " + val);
// 		getData();
// 	}
// );

watch(
    () => isRecordDeleted.value,
    () => {
        closeModals();
    }
);

watch(
    () => isRecordCreated.value,
    () => {
        closeModals();
    }
);

watch(
    () => isInformantDeleted.value,
    () => {
        closeModals();
    }
);

watch(
    () => isPatientAddressDeleted.value,
    () => {
        closeModals();
    }
);

watch(
    () => isPerpetratorDeleted.value,
    () => {
        closeModals();
    }
);

// onMounted(() => getData());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
					patientId.value && caseId.value ? _unref(router).replace(`/patient/${patientId.value}/cases/${caseId.value}/interventions`) : null
				))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["rounded py-3 px-4 overflow-hidden w-full relative min-h-[72px] flex items-center justify-between", __props.hasRecord ? 'pointer-events-none bg-[#E6E6E6]' : 'cursor-pointer bg-primary-400'])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["text-xs py-0.5 px-2 rounded-[10px]", __props.hasRecord ? 'text-neutral-500 bg-[#D4D4D4]' : 'text-primary-600 bg-[#98C7FE]'])
            }, _toDisplayString(__props.item?.interventions_count), 3),
            _createElementVNode("p", {
              class: _normalizeClass(["text-sm font-bold", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
            }, " Intervention ", 2)
          ]),
          _createVNode(_unref(ChevronRightIcon), {
            class: _normalizeClass(["w-5 h-5 p-0.5 cursor-pointer stroke-[3]", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
          }, null, 8, ["class"])
        ], 2)
      ]),
      (_unref(hasPermission)('can-manage-patient-guardian-companion-peretrator'))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Other Information "))
        : _createCommentVNode("", true),
      (_unref(hasPermission)('can-manage-patient-guardian-companion-peretrator'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["rounded py-3 px-4 overflow-hidden w-full relative min-h-[72px] flex items-center justify-between", __props.hasRecord ? 'pointer-events-none bg-[#E6E6E6]' : 'cursor-pointer bg-primary-400']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showGuardianModal.value = true))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                class: _normalizeClass(["text-xs py-0.5 px-2 rounded-[10px]", __props.hasRecord ? 'text-neutral-500 bg-[#D4D4D4]' : 'text-primary-600 bg-[#98C7FE]'])
              }, _toDisplayString(__props.item?.guardians_count), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["text-sm font-bold", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
              }, " Guardian ", 2)
            ]),
            _createVNode(_unref(ChevronRightIcon), {
              class: _normalizeClass(["w-5 h-5 p-0.5 cursor-pointer stroke-[3]", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
            }, null, 8, ["class"])
          ], 2))
        : _createCommentVNode("", true),
      (_unref(hasPermission)('can-manage-patient-guardian-companion-peretrator'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["rounded py-3 px-4 overflow-hidden w-full relative min-h-[72px] flex items-center justify-between", __props.hasRecord ? 'pointer-events-none bg-[#E6E6E6]' : 'cursor-pointer bg-primary-400']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showCompanionModal.value = true))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: _normalizeClass(["text-xs py-0.5 px-2 rounded-[10px]", __props.hasRecord ? 'text-neutral-500 bg-[#D4D4D4]' : 'text-primary-600 bg-[#98C7FE]'])
              }, _toDisplayString(__props.item?.companions_count), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["text-sm font-bold", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
              }, " Informant ", 2)
            ]),
            _createVNode(_unref(ChevronRightIcon), {
              class: _normalizeClass(["w-5 h-5 p-0.5 cursor-pointer stroke-[3]", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
            }, null, 8, ["class"])
          ], 2))
        : _createCommentVNode("", true),
      (_unref(hasPermission)('can-manage-patient-guardian-companion-peretrator'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(["rounded py-3 px-4 overflow-hidden w-full relative min-h-[72px] flex items-center justify-between", __props.hasRecord ? 'pointer-events-none bg-[#E6E6E6]' : 'cursor-pointer bg-primary-400']),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showPatientAddressModal.value = true))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(["text-xs py-0.5 px-2 rounded-[10px]", __props.hasRecord ? 'text-neutral-500 bg-[#D4D4D4]' : 'text-primary-600 bg-[#98C7FE]'])
              }, _toDisplayString(__props.item?.patient_addresses_count), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["text-sm font-bold", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
              }, " Patient Address ", 2)
            ]),
            _createVNode(_unref(ChevronRightIcon), {
              class: _normalizeClass(["w-5 h-5 p-0.5 cursor-pointer stroke-[3]", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
            }, null, 8, ["class"])
          ], 2))
        : _createCommentVNode("", true),
      (_unref(hasPermission)('can-manage-patient-guardian-companion-peretrator'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass(["rounded py-3 px-4 overflow-hidden w-full relative min-h-[72px] flex items-center justify-between", __props.hasRecord ? 'pointer-events-none bg-[#E6E6E6]' : 'cursor-pointer bg-primary-400']),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showPerpetratorModal.value = true))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass(["text-xs py-0.5 px-2 rounded-[10px]", __props.hasRecord ? 'text-neutral-500 bg-[#D4D4D4]' : 'text-primary-600 bg-[#98C7FE]'])
              }, _toDisplayString(__props.item?.perpetrators_count), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["text-sm font-bold", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
              }, " Perpetrator ", 2)
            ]),
            _createVNode(_unref(ChevronRightIcon), {
              class: _normalizeClass(["w-5 h-5 p-0.5 cursor-pointer stroke-[3]", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
            }, null, 8, ["class"])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (
					patientId.value && caseId.value
						? _ctx.$router.replace(
							__props.item.intakes || intake.value
								? `/patient/${patientId.value}/cases/${caseId.value}/intake/${
										__props.item.intakes?.id || intake.value?.id
								}/view`
								: `/patient/${patientId.value}/cases/${caseId.value}/intake/view`
						)
						: null
				))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["rounded py-3 px-4 overflow-hidden w-full relative min-h-[72px] flex items-center justify-between", __props.hasRecord ? 'pointer-events-none bg-[#E6E6E6]' : 'cursor-pointer bg-primary-400'])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", {
              class: _normalizeClass(["text-sm font-bold", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
            }, " Intake ", 2)
          ]),
          _createVNode(_unref(ChevronRightIcon), {
            class: _normalizeClass(["w-5 h-5 p-0.5 cursor-pointer stroke-[3]", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
          }, null, 8, ["class"])
        ], 2)
      ]),
      _createElementVNode("a", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (
					patientId.value && caseId.value
						? _ctx.$router.replace(
							__props.item.assessments || assessment.value
								? `/patient/${patientId.value}/cases/${caseId.value}/safety-assessment/${
										__props.item.assessments?.id || assessment.value?.id
								}/view`
								: `/patient/${patientId.value}/cases/${caseId.value}/safety-assessment/create`
						)
						: null
				))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["rounded py-3 px-4 overflow-hidden w-full relative min-h-[72px] flex items-center justify-between", __props.hasRecord ? 'pointer-events-none bg-[#E6E6E6]' : 'cursor-pointer bg-primary-400'])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", {
              class: _normalizeClass(["text-sm font-bold", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
            }, " Immediate Safety Assessment ", 2)
          ]),
          _createVNode(_unref(ChevronRightIcon), {
            class: _normalizeClass(["w-5 h-5 p-0.5 cursor-pointer stroke-[3]", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
          }, null, 8, ["class"])
        ], 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["rounded py-3 px-4 overflow-hidden w-full relative min-h-[72px] flex items-center justify-between", __props.hasRecord ? 'pointer-events-none bg-[#E6E6E6]' : 'cursor-pointer bg-primary-400']),
        onClick: _cache[7] || (_cache[7] = ($event: any) => (showCaseConferenceModal.value = true))
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", {
            class: _normalizeClass(["text-xs py-0.5 px-2 rounded-[10px]", __props.hasRecord ? 'text-neutral-500 bg-[#D4D4D4]' : 'text-primary-600 bg-[#98C7FE]'])
          }, _toDisplayString(__props.item?.case_conferences_count), 3),
          _createElementVNode("p", {
            class: _normalizeClass(["text-sm font-bold", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
          }, " Case Conference ", 2)
        ]),
        _createVNode(_unref(ChevronRightIcon), {
          class: _normalizeClass(["w-5 h-5 p-0.5 cursor-pointer stroke-[3]", __props.hasRecord ? 'text-neutral-500' : 'text-primary-600'])
        }, null, 8, ["class"])
      ], 2)
    ]),
    _createVNode(GuardianModal, {
      show: showGuardianModal.value,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (showGuardianModal.value = false)),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (showGuardianModal.value = false)),
      hasContent: ""
    }, null, 8, ["show"]),
    _createVNode(CompanionModal, {
      show: showCompanionModal.value,
      onClose: _cache[10] || (_cache[10] = ($event: any) => (showCompanionModal.value = false)),
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (showCompanionModal.value = false)),
      hasContent: ""
    }, null, 8, ["show"]),
    _createVNode(PatientAddressModal, {
      show: showPatientAddressModal.value,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (showPatientAddressModal.value = false)),
      onConfirm: _cache[13] || (_cache[13] = ($event: any) => (showPatientAddressModal.value = false)),
      hasContent: ""
    }, null, 8, ["show"]),
    _createVNode(PerpetratorModal, {
      show: showPerpetratorModal.value,
      onClose: _cache[14] || (_cache[14] = ($event: any) => (showPerpetratorModal.value = false)),
      onConfirm: _cache[15] || (_cache[15] = ($event: any) => (showPerpetratorModal.value = false)),
      hasContent: ""
    }, null, 8, ["show"]),
    _createVNode(CaseConferenceModal, {
      show: showCaseConferenceModal.value,
      onClose: _cache[16] || (_cache[16] = ($event: any) => (showCaseConferenceModal.value = false)),
      onConfirm: _cache[17] || (_cache[17] = ($event: any) => (showCaseConferenceModal.value = false)),
      hasContent: ""
    }, null, 8, ["show"])
  ]))
}
}

})